export default __webpack_public_path__ + "static/media/Dark-circle.1e2ee79b.svg";